import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import moment from "moment";
import Pagination from "react-js-pagination";

// import {
//   DateRangePicker,
//   SingleDatePicker,
//   DayPickerRangeController,
// } from "react-dates";
// import "react-dates/initialize";

// import DateRangePicker from "react-bootstrap-daterangepicker";
// you will need the css that comes with bootstrap@3. if you are using
// a tool like webpack, you can do the following:
// import "bootstrap/dist/css/bootstrap.css";
// you will also need the css that comes with bootstrap-daterangepicker
// import "bootstrap-daterangepicker/daterangepicker.css";

// import { DateRangePicker } from "react-date-range";

import DatePicker from "react-datepicker";
import {
  fetchOrders,
  searchOrder,
  fetchAllTickets,
  openOrderTicketModel,
  fetchStripeCurrency,
} from "TicketAction";
import { fetchEventDetails } from "DashboardUserAction";
import {
  itemCount,
  DEVELOPMENT_TYPE,
  screenHeightLeftFromTop,
} from "Constants";
import ExportData from "./export-data";
import OrderItem from "./order-list-item";
import OrderDetails from "./order-details";
import CreateOrderTicket from "./create-ticket-order";
import OrderRefund from "./order-refund";
import NoContent, { NO_ORDERS } from "NoContent";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Salesreport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      search: "",
      refreshLoad: false,
      startDate: "",
      endDate: "",
      // focusedInput: null,
      sortByType: "",
    };
    this.onSearchOrder = this.onSearchOrder.bind(this);
  }

  componentDidMount() {
    this.props.fetchOrders(this.props.session);
    this.props.fetchAllTickets(this.props.session);
    this.props.fetchEventDetails(this.props.session);
    this.props.fetchStripeCurrency(this.props.session);
  }

  renderSalesList() {
    let pageDataLength = this.props.orderList.resource.length;
    let { pageNumber } = this.state;

    return _.map(this.props.orderList.resource, (order) => {
      return (
        <OrderItem
          key={order.id}
          eventDetails={this.props.eventDetails}
          order={order}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
        />
      );
    });
  }

  onSearchOrder = (event) => {
    let { startDate, endDate, sortByType } = this.state;
    var search = event.target.value;
    let pageNumber = 1;
    if (search == "" && startDate == "" && endDate == "" && sortByType == "") {
      this.props.fetchOrders(
        this.props.session,
        pageNumber,
        0,
        (response) => {}
      );
    } else {
      this.props.searchOrder(
        this.props.session,
        search,
        pageNumber,
        0,
        startDate,
        endDate,
        sortByType,
        (response) => {}
      );
    }
    this.setState({ search, pageNumber });
  };

  paginationCallback = (pageNumber) => {
    let { search, startDate, endDate, sortByType } = this.state;
    // if (search == "") {
    //   this.props.fetchOrders(
    //     this.props.session,
    //     pageNumber,
    //     0,
    //     (response) => {}
    //   );
    // } else if (search != "") {
    //   this.props.searchOrder(
    //     this.props.session,
    //     search,
    //     pageNumber,
    //     0,
    //     startDate,
    //     endDate,
    //     sortByType,
    //     (response) => {}
    //   );
    // }

    if (
      search != "" ||
      (startDate != "" && endDate != "") ||
      sortByType != ""
    ) {
      this.props.searchOrder(
        this.props.session,
        search,
        pageNumber,
        0,
        startDate,
        endDate,
        sortByType,
        (response) => {}
      );
    } else {
      this.props.fetchOrders(
        this.props.session,
        pageNumber,
        0,
        (response) => {}
      );
    }

    this.setState({ ...this.state, pageNumber });
  };

  rendertotalSaleList = (totalsaleArr) => {
    let lng = totalsaleArr.length;
    return _.map(totalsaleArr, (obj, index) => {
      return (
        <td key={index}>
          {obj.currency}{" "}
          {obj.amount > 0 ? parseFloat(obj.amount).toFixed(2) : obj.amount}{" "}
          {lng - 1 != index ? "   |  " : ""}&nbsp;
        </td>
      );
    });
  };

  refreshOrderList = (buttonClick = "") => {
    let { search, pageNumber, startDate, endDate, sortByType } = this.state;

    if (buttonClick === "refresh") {
      this.setState({ refreshLoad: true });
    }

    if (search == "") {
      this.props.fetchOrders(this.props.session, pageNumber, 0, (response) => {
        this.setState({ refreshLoad: false });
      });
    } else if (search != "") {
      this.props.searchOrder(
        this.props.session,
        search,
        pageNumber,
        0,
        startDate,
        endDate,
        sortByType,
        (response) => {
          this.setState({ refreshLoad: false });
        }
      );
    }
  };

  openTicketOrder = () => {
    this.props.openOrderTicketModel(true);
  };

  exportRecord = (JSONData) => {
    var XLSX = require("xlsx");
    if (typeof XLSX == "undefined") XLSX = require("xlsx");

    /* Create a worksheet */
    var so = XLSX.utils.json_to_sheet(JSONData["Sales_Order"]);
    var oi = XLSX.utils.json_to_sheet(JSONData["Order_Item"]);

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, so, "Sales Report");
    XLSX.utils.book_append_sheet(wb, oi, "Order Item");

    /* Generate xlsx files */
    XLSX.writeFile(wb, "sales_report.xlsx");
  };

  // _handleDate = (e) => {

  //   this.setState({ startDate: e.startDate, endDate: e.endDate }, () => {});
  // };

  // handleSelect(ranges) {

  //   // {
  //   //   selection: {
  //   //     startDate: [native Date Object],
  //   //     endDate: [native Date Object],
  //   //   }
  //   // }
  // }

  _handleStartDate = (date) => {
    let { search, pageNumber, endDate, sortByType } = this.state;

    let formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    let formattedEndDate = moment(endDate).format("YYYY-MM-DD HH:mm:ss");

    this.setState({ startDate: date });
    if (endDate != "") {
      this.props.searchOrder(
        this.props.session,
        search,
        pageNumber,
        0,
        date,
        endDate,
        sortByType,
        (response) => {}
      );
    }
  };

  _handleEndDate = (date) => {
    let { search, pageNumber, startDate, sortByType } = this.state;

    let formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    let formattedStartDate = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
    this.setState({ endDate: date });
    if (startDate != "") {
      this.props.searchOrder(
        this.props.session,
        search,
        pageNumber,
        0,
        startDate,
        date,
        sortByType,
        (response) => {}
      );
    }
  };

  sortByTicketType = (e) => {
    let { search, pageNumber, startDate, endDate } = this.state;

    e.preventDefault();
    let sortByType = e.target.value;

    this.setState({ sortByType: sortByType });
    this.props.searchOrder(
      this.props.session,
      search,
      pageNumber,
      0,
      startDate,
      endDate,
      sortByType,
      (response) => {}
    );
  };

  sortByPaymentFilter = (e) => {
    let val = e.target.value;
    // console.log("selected val :- ", val);
  };
  /**
   * =============================================================================================
   */

  render() {
    let { deviceSize, eventDetails, refundModal, ticketList } = this.props;
    // console.log("this.props.orderList :- ", this.props.orderList);
    let orderList =
      this.props.orderList && this.props.orderList.resource
        ? this.props.orderList.resource
        : "";
    let totalOrderList =
      this.props.orderList && this.props.orderList.totalOrder
        ? this.props.orderList.totalOrder
        : [];

    let totalSale = 0;
    let totalPaidTicketSold = 0;
    let totalFreeTicketSold = 0;
    let totalPaidTicket = 0;
    let totalFreeTicket = 0;
    let totalCourseSold = 0;
    let totalSessionSold = 0;

    // Calculating all paid and free ticket
    if (ticketList && ticketList.length > 0) {
      _.map(ticketList, (tindex) => {
        if (tindex.tickettype == "paid") {
          totalPaidTicket += tindex.quantity;
        } else if (tindex.tickettype == "free") {
          totalFreeTicket += tindex.quantity;
        }
      });
    }
    let totalSaleArr = [];

    if (totalOrderList && totalOrderList.length > 0) {
      _.map(totalOrderList, (order) => {
        if (order.status == "approve") {
          totalSale += parseFloat(order.customeramount);

          // Calculating total paid and free ticket sold
          _.map(order.tickets_by_orderdetails, (item, index) => {
            if (item.tickettype == "paid") {
              totalPaidTicketSold =
                totalPaidTicketSold +
                parseInt(order.orderdetails_by_orderid[index].quantity);
            } else if (item.tickettype == "free") {
              totalFreeTicketSold =
                totalFreeTicketSold +
                parseInt(order.orderdetails_by_orderid[index].quantity);
            }

            if (item.type == "course") {
              // totalCourseSold++;
              totalCourseSold += parseInt(
                order.orderdetails_by_orderid[index].quantity
              );
            } else if (item.type == "session") {
              // totalSessionSold++;
              totalSessionSold += parseInt(
                order.orderdetails_by_orderid[index].quantity
              );
            }
          });

          // Calculating currency wise sold ticket amount
          if (order.customeramount > 0) {
            if (
              _.find(totalSaleArr, function (o) {
                return o.currency == order.currency;
              }) == null
            ) {
              let obj = {
                currency: order.currency,
                amount: order.customeramount,
              };
              totalSaleArr.push(obj);
            } else {
              let obj = _.find(totalSaleArr, function (o) {
                return o.currency == order.currency;
              });
              let index = _.findIndex(totalSaleArr, function (o) {
                return o.currency == order.currency;
              });
              obj.amount =
                parseFloat(obj.amount) + parseFloat(order.customeramount);
              totalSaleArr[index] = obj;
            }
          }
        }
      });
    }
    let paidTicketRemaining = totalPaidTicket - totalPaidTicketSold;
    let freeTicketRemaining = totalFreeTicket - totalFreeTicketSold;

    // const selectionRange = {
    //   startDate: new Date(),
    //   endDate: new Date(),
    //   key: "selection",
    // };

    let categories = [
      { label: "Sort by : All", value: "" },
      { label: "Course", value: "course" },
      { label: "Session", value: "session" },
    ];

    var shortByObject = [
      { label: LocaleStrings.sortby_all, value: "all" },
      { label: LocaleStrings.paid, value: "paid" },
      { label: LocaleStrings.free, value: "free" },
      { label: LocaleStrings.pending, value: "pending" },
    ];

    return (
      <div className="panel noborder-panel">
        {this.props.showTicketOrderUrlModal.showModal ? (
          <OrderDetails
            eventDetails={
              this.props.eventDetails ? this.props.eventDetails : ""
            }
          />
        ) : (
          ""
        )}
        {this.props.showOrderTicketModal &&
        this.props.showOrderTicketModal == true ? (
          <CreateOrderTicket
            eventDetails={
              this.props.eventDetails ? this.props.eventDetails : ""
            }
          />
        ) : (
          ""
        )}
        {refundModal && refundModal.show == true ? (
          <OrderRefund refreshOrder={this.refreshOrderList} />
        ) : (
          ""
        )}

        <div className="sales-header-bar">
          <div className="m-0" style={{ display: "flex" }}>
            <div className="col-lg-4 p-0">
              <div className="panel panel-default mb-0">
                <div className="panel-heading ticket-report-heading">
                  {LocaleStrings.tickets_salesreport_text_total_sales}
                </div>
                <div
                  className="panel-body"
                  style={{ backgroundColor: "#ffffff" }}
                >
                  <table>
                    <tbody>
                      <tr>
                        {totalSaleArr.length > 0
                          ? this.rendertotalSaleList(totalSaleArr)
                          : "-"}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {DEVELOPMENT_TYPE === "koachify" ? (
              <>
                <div className="col-lg-4 pr-0">
                  <div className="panel panel-default mb-0">
                    <div className="panel-heading ticket-report-heading">
                      {LocaleStrings.tickets_salesreport_text_course_sold}
                    </div>
                    <div
                      className="panel-body"
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <table>
                        <tbody>
                          <tr>{totalCourseSold}</tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 pr-0 ">
                  <div className="panel panel-default mb-0">
                    <div className="panel-heading ticket-report-heading">
                      {LocaleStrings.tickets_salesreport_text_session_sold}
                    </div>
                    <div
                      className="panel-body"
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <table>
                        <tbody>
                          <tr>{totalSessionSold}</tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-md-6 col-lg-4 paid-tc-tab1">
                  <div className="row m-0">
                    <div className="col-md-6 p-0">
                      <div className="panel panel-default mb-0">
                        <div className="panel-heading ticket-report-heading">
                          {
                            LocaleStrings.tickets_salesreport_text_paid_tickets_sold
                          }
                        </div>
                        <div
                          className="panel-body"
                          style={{ backgroundColor: "#fff" }}
                        >
                          {totalPaidTicketSold}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 p-0">
                      <div className="panel panel-default mb-0">
                        <div className="panel-heading ticket-report-heading">
                          {
                            LocaleStrings.tickets_salesreport_text_free_tickets_sold
                          }
                        </div>
                        <div
                          className="panel-body"
                          style={{ backgroundColor: "#ffffff" }}
                        >
                          {totalFreeTicketSold}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 p-0 paid-tc-tab">
                  <div className="row m-0">
                    <div className="col-md-6 p-0">
                      <div className="panel panel-default mb-0">
                        <div className="panel-heading ticket-report-heading">
                          {
                            LocaleStrings.tickets_salesreport_text_paid_tickets_remaining
                          }
                        </div>
                        <div
                          className="panel-body"
                          style={{ backgroundColor: "#ffffff" }}
                        >
                          {paidTicketRemaining}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 p-0">
                      <div className="panel panel-default mb-0">
                        <div className="panel-heading ticket-report-heading">
                          {
                            LocaleStrings.tickets_salesreport_text_free_tickets_remaining
                          }
                        </div>
                        <div
                          className="panel-body"
                          style={{ backgroundColor: "#ffffff" }}
                        >
                          {freeTicketRemaining}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="sales-second-header-bar">
          {/* <ul className="header-buttons pull-left">
            <li>
              <select
                className="dropdown-height-border p-10"
                style={{ width: 100 }}
                onChange={this.sortByPaymentFilter}
              >
                {shortByObject.map((object, index) => {
                  return (
                    <option
                      key={`${object.value}-${index}`}
                      value={object.value}
                    >
                      {object.label}
                    </option>
                  );
                })}
              </select>
            </li>
          </ul> */}
          <ul className="header-buttons pull-right">
            {DEVELOPMENT_TYPE === "koachify" ? (
              <li className="filter-dates-salesreport">
                <div>Filter by Date:</div>
                <div style={{ marginLeft: 10 }}>
                  <DatePicker
                    isClearable={this.state.startDate ? true : false}
                    placeholderText={"Start Date"}
                    selected={this.state.startDate}
                    onChange={(date) => this._handleStartDate(date)}
                    selectsStart
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                  />
                </div>
                <div style={{ marginLeft: 10 }}>
                  <DatePicker
                    isClearable={this.state.endDate ? true : false}
                    placeholderText={"End Date"}
                    selected={this.state.endDate}
                    onChange={(date) => this._handleEndDate(date)}
                    selectsEnd
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    minDate={this.state.startDate}
                  />
                </div>
              </li>
            ) : (
              ""
            )}
            {DEVELOPMENT_TYPE === "koachify" ? (
              <li>
                <select
                  className="form-control dropdown-height-border"
                  onChange={(e) => this.sortByTicketType(e)}
                  value={this.state.sortByType}
                >
                  {categories.map((object, index) => {
                    return (
                      <option
                        key={`${object.value}-${index}`}
                        value={object.value}
                      >
                        {object.label}
                      </option>
                    );
                  })}
                </select>
              </li>
            ) : (
              ""
            )}
            <li>
              <input
                className="form-control mapsearch"
                style={{ width: 358 }}
                placeholder={
                  LocaleStrings.tickets_salesreport_search_placeholder
                }
                type="text"
                value={this.state.search}
                onChange={this.onSearchOrder}
              />
            </li>
            <li>
              <Button
                bsStyle=""
                type="button"
                className="btn i-custom-refresh"
                onClick={() => this.refreshOrderList("refresh")}
              >
                <i
                  className={
                    this.state.refreshLoad
                      ? "fa fa-refresh fa-spin"
                      : "fa fa-refresh"
                  }
                  aria-hidden="true"
                ></i>
              </Button>
            </li>
            {DEVELOPMENT_TYPE === "koachify" ? (
              ""
            ) : (
              <li>
                <Button
                  bsStyle=""
                  type="button"
                  className="btn btn-custom-blue"
                  onClick={this.openTicketOrder}
                >
                  {/* <i className="fa fa-plus i-custom-m" aria-hidden="true"></i>&nbsp; {LocaleStrings.button_ticket_order} */}
                  <img
                    style={{ paddingRight: 8, paddingBottom: 3 }}
                    src="../../style/images/header-icons/plus.png"
                  ></img>
                  {LocaleStrings.button_ticket_order}
                </Button>
              </li>
            )}
            <li>
              <ExportData JSONToCSVConvertor={this.exportRecord} />
            </li>
          </ul>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{
            height: deviceSize.height - (screenHeightLeftFromTop + 125),
          }}
        >
          {this.props.orderList && this.props.orderList.resource ? (
            <>
              {orderList && orderList.length > 0 ? (
                <div className="main-table-container">
                  <table className="table" border="0">
                    <thead>
                      <tr>
                        <th>
                          {
                            LocaleStrings.tickets_salesreport_table_list_order_ref
                          }
                        </th>
                        <th>
                          {LocaleStrings.tickets_salesreport_table_list_email}
                        </th>
                        {DEVELOPMENT_TYPE === "koachify" ? (
                          <th>
                            {
                              LocaleStrings.tickets_salesreport_table_list_ticket_name
                            }
                          </th>
                        ) : (
                          <th>
                            {
                              LocaleStrings.tickets_salesreport_table_list_tickets
                            }
                          </th>
                        )}
                        <th>
                          {
                            LocaleStrings.tickets_salesreport_table_list_purchase_date
                          }
                        </th>
                        <th>
                          {
                            LocaleStrings.tickets_salesreport_table_list_order_total
                          }
                        </th>
                        <th>
                          {
                            LocaleStrings.tickets_salesreport_table_list_discount
                          }
                        </th>
                        <th>
                          {
                            LocaleStrings.tickets_salesreport_table_list_purchase_total
                          }
                        </th>
                        <th style={{ width: 300 }}>
                          {LocaleStrings.tickets_salesreport_table_list_action}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="tbody-background">
                      {this.renderSalesList()}
                    </tbody>
                  </table>
                  {this.props.orderList &&
                  this.props.orderList.count > itemCount ? (
                    <Pagination
                      activePage={this.state.pageNumber}
                      itemsCountPerPage={itemCount}
                      totalItemsCount={this.props.orderList.count}
                      pageRangeDisplayed={10}
                      onChange={this.paginationCallback}
                      style={{ float: "right" }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <NoContent contentType={NO_ORDERS} />
              )}
            </>
          ) : (
            <div className="loader-container">
              <Loader />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    ticketMenus: state.ticketMenus,
    orderList: state.OrderList,
    ticketList: state.allTicketList.resource,
    showTicketOrderUrlModal: state.showTicketOrderUrlModal,
    showOrderTicketModal: state.showOrderTicketModal,
    eventDetails: state.userEventDetails,
    refundModal: state.refundModalShow,
  };
}
export default connect(mapStateToProps, {
  fetchOrders,
  searchOrder,
  fetchAllTickets,
  openOrderTicketModel,
  fetchEventDetails,
  fetchStripeCurrency,
})(Salesreport);
